import React from "react";
import EarnMore from "../../assets/images/benefits/earning.svg";
import Monetize from "../../assets/images/benefits/earning.svg";
import SustainabilityCertifcation from "../../assets/images/benefits/sustainability-certification.svg";

import USPSection2Cards from "../../components/USPSection2/USPSection2Cards";
import { Row, Col } from "react-bootstrap";

const EcoEntrepreneurBenefits = () => {
  const benefits = [
    {
      title: "Grow Eco-Bee & Earn more",
      bodycopy:
        "Cultivate and manage Eco-Bee on behalf of a third party, leveraging expertise to optimize growth and enhance returns.",
      image: EarnMore,
    },
  
    {
      title: "Monetize unutilized farming capacity",
      bodycopy:
        "Monetizing unutilized farming capacity through honey contract farming and Adoptable Eco-Bee service offered by ApisChain to maximize profit.",
      image: Monetize,
    },

    {
      title: "Sustainability Certificate",
      bodycopy:
        "A Sustainability Certificate benefits eco-entrepreneurs by enhancing their credibility, attracting environmentally-conscious customers, and opening doors to premium markets focused on sustainable practices.",
      image: SustainabilityCertifcation,
    },
  ];
  return (
    <>
 
      <Row>
        {benefits.map((e, index) => {
          return (
            <Col md={4} key={index}>
              <USPSection2Cards
                cardtitle={e.title}
                src={e.image}
                cardBodycopy={e.bodycopy}
              />
            </Col>
          );
        })}
      </Row>
    </>
  );
};

export default EcoEntrepreneurBenefits;
